import { FormEvent, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { useToast } from "../components/ui/use-toast";
import * as authService from "../services/autService";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await authService.forgotPassword({ email });
      toast({
        title: t("auth.forgotPassword.successTitle"),
        description: t("auth.forgotPassword.successDescription"),
        variant: "success",
      });
      navigate("/login", { replace: true });
    } catch (err) {
      const message =
        typeof err === "string"
          ? err
          : err instanceof Error
          ? err.message
          : t("auth.forgotPassword.errorDescription");
      toast({
        title: t("auth.forgotPassword.errorTitle"),
        description: message,
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-md space-y-6 rounded-3xl border border-border bg-card p-8 text-foreground shadow-lg dark:border-white/10 dark:bg-white/5 dark:text-white">
      <div>
        <h2 className="text-2xl font-semibold">{t("auth.forgotPassword.title")}</h2>
        <p className="text-sm text-muted-foreground dark:text-white/70">
          {t("auth.forgotPassword.subtitle")}
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">{t("auth.forgotPassword.emailLabel")}</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            placeholder={t("auth.forgotPassword.emailPlaceholder")}
          />
        </div>
        <Button type="submit" className="w-full" disabled={isLoading}>
          {isLoading ? t("auth.forgotPassword.submitting") : t("auth.forgotPassword.submit")}
        </Button>
      </form>
      <div className="text-center">
        <Link
          to="/login"
          className="text-sm text-primary underline hover:text-primary/80 dark:text-white/70 dark:hover:text-white"
        >
          {t("auth.forgotPassword.backToLogin")}
        </Link>
      </div>
    </section>
  );
};

export default ForgotPasswordPage;

